import {Controller} from "stimulus";

// Keeps a route select's unsaved pick when its options are replaced (the
// assign screen refreshes every location row's route choices after a route
// joins a cycle). The pick is remembered on change and put back after each
// replacement; a pick whose route is no longer offered is dropped.
export default class extends Controller {
    connect() {
        this.remember();
        this.observer = new MutationObserver(() => this.restore());
        this.observer.observe(this.element, {childList: true});
    }

    disconnect() {
        this.observer.disconnect();
    }

    remember() {
        this.pick = this.element.value;
    }

    restore() {
        const offered = Array.from(this.element.options).some((option) => option.value === this.pick);
        if (!offered) this.pick = "";
        this.element.value = this.pick;
    }
}
